import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/apply-avatar.jpg'
import _imports_1 from '@/assets/images/apply-poster.jpg'


const _withScopeId = n => (_pushScopeId("data-v-19e2a99a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-section" }
const _hoisted_2 = { class: "page-flexwrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "360",
    height: "240",
    alt: "アバター試着室"
  })
], -1))
const _hoisted_4 = { class: "page-flexinner" }
const _hoisted_5 = { class: "page-flexwrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "360",
    height: "240",
    alt: "ポスター展示"
  })
], -1))
const _hoisted_7 = { class: "page-flexinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-apply" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_6')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_3')), 1)
        ]),
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_4')), 1),
              _createVNode(_component_Heading, { tag: "h3" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_1')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_5')), 1),
              _createVNode(_component_Heading, { tag: "h3" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_2')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_6')), 1)
            ])
          ]),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_5')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_5')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_6')), 1)
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_1')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_6')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", null, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_7')), 1),
              _createVNode(_component_Heading, { tag: "h3" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_4')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_8')), 1),
              _createVNode(_component_Heading, { tag: "h3" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_5')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_9')), 1)
            ])
          ]),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_6')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_7')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_8')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_9')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_10')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_11')), 1)
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_4')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_6')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}